import { Component } from '@angular/core';

@Component({
	selector: 'app-scenario-five',
	templateUrl: './scenario-five.component.html',
	styleUrls: ['./scenario-five.component.scss']
})
export class ScenarioFiveComponent {
	registrationPlates;
	vinNumber;

	show: boolean = true;

	saveNameForm(registrationPlates, vinNumber) {}
}
